import { Sun } from "@rhinov/savane-js";
import { EntityController } from "./EntityController";

export class SunEntityController extends EntityController {

    declare entity: Sun;

    constructor(entity: Sun, panel: any) {
        super(entity, panel, null, null);
    }
}